import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import tiranaImg from "../../assets/tirana.jpg";

const Hero: React.FC = () => {
  const { t } = useTranslation("latest-news");
  return (
    <Box
      sx={{
        position: "relative",
        height: "60vh",
        backgroundImage: `url(${tiranaImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0, 0, 0, 0.80)",
        }}
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 10,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          textAlign: "center",
          color: "white",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "2.5rem", md: "3rem", lg: "3.5rem" },
            fontWeight: "600",
            marginBottom: 2,
            maxWidth: "750px",
            color: "#FFFFFF",
            textTransform: "uppercase",
          }}
        >
          {t("latest")}
        </Typography>
        <p className="text-lg max-w-4xl mb-8 px-4">{t("hero-text")}</p>
      </Box>
    </Box>
  );
};

export default Hero;
